export enum PLAYLIST_TYPES {
  ALBUM = 'album',
  CUSTOM_PLAYLIST = 'custom_playlist',
  CURATED_PLAYLIST = 'curated_playlist',
  COMPILATION = 'compilation',
}
